module.exports = __webpack_public_path__ + "c07c43c7653add22910ff23c77a4e273.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/10_A2.mp3
// module id = 90
// module chunks = 0